'use client';

import React from 'react';
import { mergeClasses } from 'minimal-shared/utils';

export type MainSectionProps = React.HTMLAttributes<HTMLElement>;

export function MainSection({ children, className, ...other }: MainSectionProps) {
  return (
    <main className={mergeClasses(['flex flex-col flex-1 h-full', className])} {...other}>
      {children}
    </main>
  );
}
